var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasicoIntermedioSinFondo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "4 6 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_1101)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1403 5.33606C12.0507 5.30987 11.9554 5.30986 11.8657 5.33602L5.98539 7.05215C5.77645 7.11312 5.63281 7.30467 5.63281 7.52233V11.0401C5.63281 14.9509 8.1358 18.4229 11.8462 19.6588C11.9467 19.6923 12.0553 19.6923 12.1558 19.6588C15.8653 18.4228 18.3675 14.9516 18.3675 11.0417V7.52233C18.3675 7.30472 18.2239 7.1132 18.015 7.05218L12.1403 5.33606ZM12.2655 18.5803C15.3422 17.3639 17.3869 14.384 17.3869 11.0456V8.04331C17.3869 7.95446 17.3283 7.87625 17.243 7.85134L12.258 6.39511C12.1299 6.35771 12.0019 6.4537 12.0019 6.58705L12 18.3965C12 18.5348 12.1369 18.6312 12.2655 18.5803Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_1101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicoIntermedioSinFondo);
export default __webpack_public_path__ + "static/media/basico_intermedio_sin_fondo.6e7d80b0ba96578cf42e92373091b45c.svg";
export { ForwardRef as ReactComponent };